import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'fold-card',
  props: {
    label: {
      type: String,
      require: true
    },
    fold: {
      type: Boolean,
      default: true
    },
    foldTxt: {
      type: String,
      default: '收起'
    },
    unFoldTxt: {
      type: String,
      default: '展开'
    },
    maxLines: {
      type: Number,
      default: 3
    },
    contentTxt: {
      type: String,
      require: true
    }
  },
  data: function data() {
    return {
      showAll: false,
      shouldShowFoldBtn: true
    };
  },
  watch: {
    fold: function fold(val) {
      this.showAll = !val;
    },
    contentTxt: 'checkFold'
  },
  mounted: function mounted() {
    this.checkFold();
  },
  methods: {
    toggleFold: function toggleFold() {
      this.showAll = !this.showAll;
    },
    checkFold: function checkFold() {
      this.shouldShowFoldBtn = true;
      if (this.$refs.contentWrapper.offsetHeight < this.maxLines * 20 - 5) {
        this.shouldShowFoldBtn = false;
      }
    }
  }
};